module.exports = __webpack_public_path__ + "img/alb-dark.266b2567.svg";